/**
 * Redux slice (src/store/slices/enquirySlice.js).
 *
 * Data flow (typical):
 * - UI dispatches actions/thunks from `src/store/actions/*`.
 * - `reducers` handles synchronous state updates.
 * - `extraReducers` reacts to thunk pending/fulfilled/rejected actions.
 */

import { createSlice } from "@reduxjs/toolkit";
import { Create_Enquiry, Create_Enquiry_Student, Delete_Admin_Enquiry, Delete_Enquiry, FetchAll_Enquiry, Fetch_Student_Enquiry, SearchEnquirybyStudentUsername } from "../actions/enquiryActions";
import { toast } from "react-toastify";

let intialState = {
  enquirylist:[],
  enquiryDetails:[],
  Student_Enquiry:[],
  loading: false,
  error: null,
};

/**
 * RTK slice definition: enquirySlice.
 */
const enquirySlice = createSlice({
  name: "enquiry",
  initialState: intialState,
  reducers: {

  },
  /**
   * Reducer: extraReducers.
   */
  extraReducers: (builder) => {
    builder
      // extraReducers handler: Delete_Enquiry.pending
      .addCase(Delete_Enquiry.pending, (state) => {
        state.loading = true;
      })
      // extraReducers handler: Delete_Enquiry.fulfilled
      .addCase(Delete_Enquiry.fulfilled, (state, action) => {
        // state.enquirylist = action.payload
        // Delete_Enquiry
         state.enquirylist = state.enquirylist.filter(
           (enquiry) => enquiry._id !== action.payload.DeletedEnquiry._id
         );
        state.loading = false;
      })
      // extraReducers handler: Delete_Enquiry.rejected
      .addCase(Delete_Enquiry.rejected, (state) => {
        state.loading = false;
      })
      .addCase(Delete_Admin_Enquiry.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(Delete_Admin_Enquiry.fulfilled, (state, action) => {
        state.enquirylist = state.enquirylist.filter(
          (enquiry) => enquiry._id !== action.payload.DeletedEnquiry._id
        );
        state.loading = false;
      })
      .addCase(Delete_Admin_Enquiry.rejected, (state) => {
        state.loading = false;
        state.error = 'Nie udało się usunąć zapytania.';
      })
      // extraReducers handler: FetchAll_Enquiry.pending
      .addCase(FetchAll_Enquiry.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      // extraReducers handler: FetchAll_Enquiry.fulfilled
      .addCase(FetchAll_Enquiry.fulfilled, (state, action) => {
        state.enquirylist = action.payload
        state.loading = false;
        state.error = null;
      })
      // extraReducers handler: FetchAll_Enquiry.rejected
      .addCase(FetchAll_Enquiry.rejected, (state) => {
        state.loading = false;
        state.error = 'Nie udało się pobrać zapytań.';
      })
      // extraReducers handler: Create_Enquiry.pending
      .addCase(Create_Enquiry.pending, (state) => {
        state.loading = true;
      })
      // extraReducers handler: Create_Enquiry.fulfilled
      .addCase(Create_Enquiry.fulfilled, (state, action) => {
        state.loading = false;
      })
      // extraReducers handler: Create_Enquiry.rejected
      .addCase(Create_Enquiry.rejected, (state) => {
        state.loading = false;
      })
      // extraReducers handler: Fetch_Student_Enquiry.pending
      .addCase(Fetch_Student_Enquiry.pending, (state) => {
        state.loading = true;
      })
      // extraReducers handler: Fetch_Student_Enquiry.fulfilled
      .addCase(Fetch_Student_Enquiry.fulfilled, (state, action) => {
        state.Student_Enquiry = action.payload
        state.loading = false;
      })
      // extraReducers handler: Fetch_Student_Enquiry.rejected
      .addCase(Fetch_Student_Enquiry.rejected, (state) => {
        state.loading = false;
      })
      // extraReducers handler: Create_Enquiry_Student.pending
      .addCase(Create_Enquiry_Student.pending, (state) => {
        state.loading = true;
      })
      // extraReducers handler: Create_Enquiry_Student.fulfilled
      .addCase(Create_Enquiry_Student.fulfilled, (state, action) => {
        state.loading = false;
      })
      // extraReducers handler: Create_Enquiry_Student.rejected
      .addCase(Create_Enquiry_Student.rejected, (state) => {
        state.loading = false;
      })
      // SearchEnquirybyStudentUsername
      .addCase(SearchEnquirybyStudentUsername.pending, (state) => {
        state.loading = true;
      })
      // extraReducers handler: SearchEnquirybyStudentUsername.fulfilled
      .addCase(SearchEnquirybyStudentUsername.fulfilled, (state, action) => {
        if (action.payload && action.payload.data) {
          state.enquirylist = action.payload.data.foundedEnquiry          
          state.loading = false;
        } else {
          state.enquirylist = action.payload.data
          toast.warning(action.payload, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        }
      })
      // extraReducers handler: SearchEnquirybyStudentUsername.rejected
      .addCase(SearchEnquirybyStudentUsername.rejected, (state) => {
        state.loading = false;
      })
      
  },
});

// export const { } = coursesSlice.actions;
export default enquirySlice.reducer;
